module.exports = __webpack_public_path__ + "static/lawadvisor-homepage-01-a80fbc91f034be662b67873ad8863eab.jpg";